import * as React from 'react';
import { Checkbox } from '@cian/ui-kit';
import { useDispatch, useSelector } from 'react-redux';
import { selectAll, unselectAll } from '../../actions/selected';
import { selectAllEntities, selectIsAllEntitiesSelected } from '../../selectors/selected';
import { trackCheckboxAllClick } from './tracking';
import { selectResults } from '../../selectors/results';

export const CheckboxAllContainer: React.FC = () => {
  const dispatch = useDispatch();
  const isChecked = useSelector(selectIsAllEntitiesSelected);
  const allIds = useSelector(selectAllEntities);
  const results = useSelector(selectResults);
  const { favoriteEntities } = results;

  const onChange = () => {
    trackCheckboxAllClick(favoriteEntities);

    return dispatch(isChecked ? unselectAll() : selectAll({ ids: allIds }));
  };

  return <Checkbox checked={isChecked} onChange={onChange} />;
};
